
import { User } from "@twilio/conversations";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { gAPI_Vouchers_List, gAPI_Voucher_Stats, gAPI_Invitation_By_Property, API_Ingetration } from "../../../../../constants/APIs";
import { getGroupID, AxiosAPI } from "../../../../../helpers/AxiosAPI";

const UserGuide = ({ propertyId, email, locale }) => {
  const [showFrame, setShowFrame] = useState(true);
  const [intregations, setIntregations] = useState(true);
  const [invitation, setInvitations] = useState(true);
  const [statsData, setStatsData] = useState('');
  useEffect(() => {
    if (showFrame) {
      let intregations = [];
      let invitation = [];
      let statsData = [];
      AxiosAPI({
        url: `${gAPI_Invitation_By_Property}?group_id=${getGroupID()}&property_id=${propertyId}`,
        method: 'get',
      }).then((res) => {
        invitation = (res.data);
      });      
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Voucher_Stats}`,
        params: {
          group_id: getGroupID(),
          property_id: propertyId,
          fromDate: moment(
            moment().subtract(6, 'days').format('YYYY-MM-DD') + ' 00:00:00'
          )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss'),
          toDate: moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss'),
          type: 'Day',
        },
      }).then((res) => {
        try
        {
        let v = 0;
        res.data.voucher.map((m) => {
          v = v + parseInt(m.views);
        });
        statsData = ({ views: v });
      }catch{
        
      }
      });
      let body={
        channels:['Stripe','VoucherWebsite']
      };
      AxiosAPI({
        method: 'post',
        url: `${API_Ingetration}?group_id=${getGroupID()}`,
        data: body
      }).then((res) => {
        intregations = (res.data);
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Vouchers_List}?groupId=${getGroupID()}&propertyId=${propertyId}&languageCode=${locale}&search=&status=All&pageNumber=1&pageSize=10000&email=${email}`,
        })
          .then((res) => {
            if (res.data.vouchers !== undefined && res.data.vouchers.length > 0)
              res.data.vouchers = res.data.vouchers.filter((f) => f.thirdPartyVoucher === false);

            if (res.data.vouchers !== undefined && res.data.vouchers.length > 0) {
              if (invitation.length === 0) {
                const voucherIntegrationData = intregations.filter(
                  (k) => k.channel === 'VoucherWebsite'
                );
                let webIntregation = voucherIntegrationData.filter((f) => f.properties.includes(propertyId));

                if (webIntregation.length === 0) {
                  console.log("userGuide:1");
                  window.parent.postMessage('userGuide:1', '*');
                }
              }
            }
            if (res.data.vouchers !== undefined && res.data.vouchers.length >  0 && intregations.filter(
              (k) => k.channel === 'VoucherWebsite' && k.properties.includes(propertyId)
            ).length > 0 && invitation.length === 0 && statsData.views > 5) {
              console.log("userGuide:2");
              window.parent.postMessage('userGuide:2', '*');
            }
            if (res.data.vouchers !== undefined && res.data.vouchers.length > 0 && intregations.filter(
              (k) => k.channel === 'VoucherWebsite' && k.properties.includes(propertyId)
            ).length > 0 && intregations.filter(
              (k) => k.channel === 'Stripe' && k.properties.includes(propertyId)).length === 0
            ) {
              console.log("userGuide:3");
              window.parent.postMessage('userGuide:3', '*');
            }
          });
      });
    }
    setShowFrame(false);
  }, [invitation, intregations, statsData]);
  const windowMessage = () => {
    window.parent.postMessage("ShowUserGuide", "*")
  }
  return (
    <div>
      {/* {showFrame && 
         <div>
            <iframe src="https://app.bookmebob.com/app/pages/integration?__ug__=53966"></iframe>
        </div>} */}
    </div>
  );
}
const mapStateToProps = ({ settings }) => {

  const {
    locale,
    propertyId,


    email,

  } = settings;

  return {

    locale,

    propertyId,

    email,

  };
};

const mapActionsToProps = {};

const aap = injectIntl(UserGuide);
export default connect(mapStateToProps, mapActionsToProps)(aap);
